import { Skeleton } from '@shared/components/ui/skeleton';

interface BreadcrumbLabelProps {
  isLoading?: boolean;
  label?: string;
}

export const BreadcrumbLabel = ({ label, isLoading }: BreadcrumbLabelProps) => {
  return (
    <span className="inline-flex items-center justify-center min-w-12 h-5 transition-all text-inherit px-0 mx-0">
      {isLoading ? (
        <Skeleton className="h-3 w-full rounded-sm" />
      ) : (
        <span className="leading-none">{label ?? '--'}</span>
      )}
    </span>
  );
};
